export default __webpack_public_path__ + "static/media/4-Cloudxier-DailyCaffeine.f110cce2.jpg";